import { Stack, styled } from "@tm/components"
import { getComponentFromBundle } from "@tm/utils"
import { TyresSearchWidget } from "@bundles/tyres"
import SearchTreeWidget from "@bundles/vehicle/components/search-tree-widget"
import DirectSearchWidgetComponent from "@bundles/parts/components/direct-search-widget"
import { WidgetStart as CustomerSearchWidget } from "@bundles/crm"
import searchWidget from "@bundles/parts/components/uni-search-widget"
import { startWMChannel } from "./channel"

// Styled Components
export const StyledStack = styled(Stack)(() => ({
    overflowY: "scroll",
    backgroundColor: "white",
    width: "100%",

    ".widget__card": {
        border: "none",
        background: "none",

        "&::before": {
            border: "none",
        },

        "&:hover": {
            background: "none",
            boxShadow: "none",
        },
    },
}))

// Styled Widgets
const DirectSearchWidget = getComponentFromBundle(DirectSearchWidgetComponent, startWMChannel)
const UniSearchWidget = getComponentFromBundle(searchWidget, startWMChannel)
const VehicleSearchWidget = getComponentFromBundle(SearchTreeWidget, startWMChannel)

export const StyledDirectSearchWidget = styled(DirectSearchWidget)(() => ({
    flexDirection: "column",
}))

export const StyledUniSearchWidget = styled(UniSearchWidget)(() => ({
    width: "100%",
    padding: 0,
    height: "64px",

    "&.widget": {
        "& .widget__card": {
            padding: 0,

            "& .widget__inner": {
                "& .widget__header": {
                    display: "none",
                },
                "& .widget__content": {
                    position: "inherit",
                    "& .upper > div": {
                        width: "100%",
                    },
                },
            },
        },
    },
}))

export const StyledCustomerSearchWidget = styled(CustomerSearchWidget)(() => ({
    "& .widget__inner": {
        padding: 0,

        "& .widget__header": {
            marginBottom: 0,
        },

        "& .line": {
            width: "100%",
        },
    },

    width: "100%",
    height: "20%",
    padding: 0,
}))

export const StyledTyresWidget = styled(TyresSearchWidget)(() => ({
    "&.widget": {
        height: "500px !important",
        padding: 0,
        "& .widget__inner": {
            padding: 0,
            "& .widget__header": {
                display: "none !important",
            },
        },
    },
}))

export const StyledVehicleWidget = styled(VehicleSearchWidget)(() => ({
    "&.widget": {
        padding: 0,
        "& .widget__card": {
            "& .widget__inner": {
                padding: 0,
                "& .widget__header": {
                    display: "none !important",
                },
                "& .widget__content": {
                    "& .line, .button-container .vehiclesearch": {
                        width: "100%",
                    },
                },
            },
        },
    },
}))
